import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { QualificationSummary } from './QualificationSummary';

export class QualificationSummaryResource extends FBaseService {
  public async getQualificationSummary(fiId: string, cycleId: number): Promise<QualificationSummary[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/qualification-summary/${cycleId}`,

    );
    const results: QualificationSummary[] = response.data.data;
    return results;
  }
}

export default QualificationSummaryResource;
